export default "__VITE_ASSET__BAbaqDhK__"